import { useState } from "react";
import { buildSmartLinkPayload } from "../utils/buildPayload";
import { createSmartLinkService } from "../services/smartLinksService";
import { isLimitError } from "../components/LimitErrorModal.jsx";

export const useSmartLinks = () => {

  const [formData, setFormData] = useState({
    merchantName: "",
    phoneNumber: "",
    paymentType: "unique",
    description: "",
    currency: "MXN",
    paymentMethod: "credit-card",
    email: "",
    price: "",
    productName: "",
    frequency: "monthly",
    startDate: "",
    executionLimit: "",
    limitType: "0",
    minAmount: "",
    maxAmount: "",
    defaultAmount: "",
    taxEnabled: false,
    taxPercentage: ""
  });

  const [loading, setLoading] = useState(false);
  const [createdLink, setCreatedLink] = useState("");
  const [limitModalError, setLimitModalError] = useState(null);

  const closeLimitModal = () => setLimitModalError(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const validateForm = () => {
    const priceValue = Number(formData.price);

    if (formData.paymentType === "unique" && !(priceValue >= 50)) {
      alert("El precio debe ser mayor a 0.");
      return false;
    }

    if (formData.paymentType === "open") {
      if (!(formData.minAmount > 49) || !(formData.maxAmount > 49)) {
        alert("Debes definir montos mínimos y máximos válidos. mayores a 50");
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setCreatedLink("");

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    try {
      const payload = buildSmartLinkPayload(formData);
      const data = await createSmartLinkService(payload, "kushki");

      if (data?.smartLinkUrl) {
        setCreatedLink(data.smartLinkUrl);
        window.open(data.smartLinkUrl, "_blank");
      } else {
        throw new Error(data.message || "Respuesta sin smartLinkUrl.");
      }

    } catch (error) {
      console.error(error);
      if (isLimitError(error.message)) {
        setLimitModalError(error.message);
      } else {
        alert(`Error creando SmartLink: ${error.message}`);
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    createdLink,
    limitModalError,
    closeLimitModal,
    handleChange,
    handleSubmit,
  };
};
